(function () {
        'use strict';
        var endpoint = 'https://gefcompany.app.n8n.cloud/webhook/form-confirm';
        var messages = {
          name: 'Inserisci il tuo nome',
          email: 'Email non valida (es. nome@azienda.it)',
          phone: 'Inserisci un numero di telefono valido',
          vat: 'P.IVA non valida (prefisso paese opzionale, 6-15 cifre)'
        };
        function fieldKind(field) {
          var raw = ((field.getAttribute('name') || '') + ' ' + (field.id || '') + ' ' + (field.getAttribute('autocomplete') || '')).toLowerCase();
          if (raw.indexOf('email') !== -1) return 'email';
          if (raw.indexOf('phone') !== -1 || raw.indexOf('tel') !== -1 || raw.indexOf('telefono') !== -1) return 'phone';
          if (raw.indexOf('vat') !== -1 || raw.indexOf('iva') !== -1 || raw.indexOf('partita') !== -1) return 'vat';
          if (raw.indexOf('name') !== -1 || raw.indexOf('nome') !== -1) return 'name';
          return '';
        }
        function errorNode(field) {
          var node = field.parentElement && field.parentElement.querySelector('[data-gef-field-error-for="' + field.name + '"]');
          if (!node && field.parentElement) {
            node = document.createElement('small');
            node.className = 'gef-form-field-error';
            node.setAttribute('data-gef-field-error-for', field.name);
            field.insertAdjacentElement('afterend', node);
          }
          return node;
        }
        function syncError(field) {
          var node = errorNode(field);
          if (!node) return;
          var kind = fieldKind(field);
          var msg = field.validationMessage;
          if (field.validity.valueMissing && kind === 'name') msg = messages.name;
          if ((field.validity.typeMismatch || field.validity.valueMissing) && kind === 'email') msg = messages.email;
          if ((field.validity.patternMismatch || field.validity.valueMissing) && kind === 'phone') msg = messages.phone;
          if (field.validity.patternMismatch && kind === 'vat') msg = messages.vat;
          node.textContent = field.validity.valid ? '' : msg;
        }
        function addHidden(form, name, value) {
          if (form.querySelector('[name="' + name + '"]')) return;
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          form.appendChild(input);
        }
        document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
          if (!form.id) form.id = 'gef-form-' + Math.random().toString(36).slice(2, 8);
          var isNewsletter = !!form.querySelector('[name="klaviyo_list"], [name="contact[accepts_marketing]"]');
          addHidden(form, 'contact[form_page]', window.location.pathname);
          addHidden(form, 'contact[form_id]', form.id);
          form.querySelectorAll('input, select, textarea').forEach(function (field) {
            if (!field.name) return;
            field.addEventListener('invalid', function () { syncError(field); });
            field.addEventListener('blur', function () { syncError(field); });
            field.addEventListener('input', function () { field.setCustomValidity(''); syncError(field); });
          });
          form.addEventListener('submit', function () {
            if (isNewsletter) return;
            var email = form.querySelector('[name="contact[email]"]');
            if (!email || !email.value) return;
            var payload = {};
            new FormData(form).forEach(function (value, key) {
              if (Object.prototype.hasOwnProperty.call(payload, key)) {
                if (!Array.isArray(payload[key])) payload[key] = [payload[key]];
                payload[key].push(value);
              } else {
                payload[key] = value;
              }
            });
            payload.form_id = form.id;
            payload.page = window.location.pathname;
            payload.submitted_at = new Date().toISOString();
            try {
              window.fetch(endpoint, {
                method: 'POST',
                mode: 'no-cors',
                keepalive: true,
                headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
                body: JSON.stringify(payload)
              });
            } catch (err) {}
          }, { capture: true });
        });
      })();
